import React from "react";
import Brands from "../home/brands/Brands";
import Why_choose_us from "../home/why_choose_us.js/Why_choose_us";
import Who_we_are from "../home/who_we_are/Who_we_are";
import Success_speaks from "../home/success_speaks/Success_speaks";
import Need_advice from "../home/need_advice/Need_advice";
import Get_started from "../home/get_started/Get_started";
import About_banner from "./about_banner/About_banner";
import Our_story from "./our_story/Our_story";
import Our_process from "./our_process/Our_process";
import Meet_our_team from "./meet_our_team/Meet_our_team";

function About_us() {
  return (
    <>
    <About_banner/>
    <Brands/>
    <Why_choose_us/>
    <Our_story/>
    <Who_we_are/>
    <Our_process/>
    <Meet_our_team/>
    <Success_speaks/>
    <Need_advice imgSrc="/assets/images/home/need_advice/section_img_2.webp"/>
    <Get_started/>
    </>
  );
}

export default About_us;
